export class NotificationArguments {
    'restoreJobFailed';
    'restoreJobSucceeded';
    'backupJobFailed';
    'backupJobSucceeded';
    'cloudAccountCreated';
    'cloudAccountUpdated';
    'cloudAccountDeleted';
    'cloudAccountDeactivated';
    'cloudAccountActivated';
    'backupPolicyApplied';
    'backupPolicyUnApplied';
    'backupPolicyCreated';
    'backupPolicyUpdated';
    'backupPolicyDeleted';
    'backupVaultCreated';
    'backupVaultDeleted';
    'resourceExcludedFromRansomwareDetection';
    'ransomwareDetectionExclusionCanceled';
    'ransomwareDetectedInResource';
    'ransomwareDetectedInSnapshot';
    'ransomwareInfectionRemediated';
    'violationsDetected';
    'violationsResolved';
    'issueMuted';
    'issueUnmuted';
    'jobMetricsReportFailed';
    'classificationJobFailed';
    'creditsNotification';
    'creditsMonthlyUsageNotification';
    'malwareDetectedInSnapshot';
    'dataAnomalyDetectedInSnapshot';
    'malwareRemediated';
    'dataAnomalyRemediated';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreJobFailed",
            "baseName": "restoreJobFailed",
            "type": "JobFailedNotificationArguments",
            "format": ""
        },
        {
            "name": "restoreJobSucceeded",
            "baseName": "restoreJobSucceeded",
            "type": "JobSucceededNotificationArguments",
            "format": ""
        },
        {
            "name": "backupJobFailed",
            "baseName": "backupJobFailed",
            "type": "JobFailedNotificationArguments",
            "format": ""
        },
        {
            "name": "backupJobSucceeded",
            "baseName": "backupJobSucceeded",
            "type": "JobSucceededNotificationArguments",
            "format": ""
        },
        {
            "name": "cloudAccountCreated",
            "baseName": "cloudAccountCreated",
            "type": "CloudAccountNotificationArguments",
            "format": ""
        },
        {
            "name": "cloudAccountUpdated",
            "baseName": "cloudAccountUpdated",
            "type": "CloudAccountNotificationArguments",
            "format": ""
        },
        {
            "name": "cloudAccountDeleted",
            "baseName": "cloudAccountDeleted",
            "type": "CloudAccountNotificationArguments",
            "format": ""
        },
        {
            "name": "cloudAccountDeactivated",
            "baseName": "cloudAccountDeactivated",
            "type": "CloudAccountNotificationArguments",
            "format": ""
        },
        {
            "name": "cloudAccountActivated",
            "baseName": "cloudAccountActivated",
            "type": "CloudAccountNotificationArguments",
            "format": ""
        },
        {
            "name": "backupPolicyApplied",
            "baseName": "backupPolicyApplied",
            "type": "BackupPolicyAppliesNotificationArguments",
            "format": ""
        },
        {
            "name": "backupPolicyUnApplied",
            "baseName": "backupPolicyUnApplied",
            "type": "BackupPolicyAppliesNotificationArguments",
            "format": ""
        },
        {
            "name": "backupPolicyCreated",
            "baseName": "backupPolicyCreated",
            "type": "BackupPolicyNotificationArguments",
            "format": ""
        },
        {
            "name": "backupPolicyUpdated",
            "baseName": "backupPolicyUpdated",
            "type": "BackupPolicyNotificationArguments",
            "format": ""
        },
        {
            "name": "backupPolicyDeleted",
            "baseName": "backupPolicyDeleted",
            "type": "BackupPolicyNotificationArguments",
            "format": ""
        },
        {
            "name": "backupVaultCreated",
            "baseName": "backupVaultCreated",
            "type": "VaultNotificationArguments",
            "format": ""
        },
        {
            "name": "backupVaultDeleted",
            "baseName": "backupVaultDeleted",
            "type": "VaultNotificationArguments",
            "format": ""
        },
        {
            "name": "resourceExcludedFromRansomwareDetection",
            "baseName": "resourceExcludedFromRansomwareDetection",
            "type": "RansomwareResourceNotificationArguments",
            "format": ""
        },
        {
            "name": "ransomwareDetectionExclusionCanceled",
            "baseName": "ransomwareDetectionExclusionCanceled",
            "type": "RansomwareResourceNotificationArguments",
            "format": ""
        },
        {
            "name": "ransomwareDetectedInResource",
            "baseName": "ransomwareDetectedInResource",
            "type": "RansomwareResourceNotificationArguments",
            "format": ""
        },
        {
            "name": "ransomwareDetectedInSnapshot",
            "baseName": "ransomwareDetectedInSnapshot",
            "type": "SecuritySnapshotNotificationArguments",
            "format": ""
        },
        {
            "name": "ransomwareInfectionRemediated",
            "baseName": "ransomwareInfectionRemediated",
            "type": "RansomwareResourceNotificationArguments",
            "format": ""
        },
        {
            "name": "violationsDetected",
            "baseName": "violationsDetected",
            "type": "ViolationsDetectionNotificationArguments",
            "format": ""
        },
        {
            "name": "violationsResolved",
            "baseName": "violationsResolved",
            "type": "ViolationsDetectionNotificationArguments",
            "format": ""
        },
        {
            "name": "issueMuted",
            "baseName": "issueMuted",
            "type": "IssueMutedNotificationArguments",
            "format": ""
        },
        {
            "name": "issueUnmuted",
            "baseName": "issueUnmuted",
            "type": "IssueMutedNotificationArguments",
            "format": ""
        },
        {
            "name": "jobMetricsReportFailed",
            "baseName": "jobMetricsReportFailed",
            "type": "JobMetricsReportFailedArguments",
            "format": ""
        },
        {
            "name": "classificationJobFailed",
            "baseName": "classificationJobFailed",
            "type": "JobFailedNotificationArguments",
            "format": ""
        },
        {
            "name": "creditsNotification",
            "baseName": "creditsNotification",
            "type": "CreditsNotificationArguments",
            "format": ""
        },
        {
            "name": "creditsMonthlyUsageNotification",
            "baseName": "creditsMonthlyUsageNotification",
            "type": "CreditsMonthlyUsageNotificationArguments",
            "format": ""
        },
        {
            "name": "malwareDetectedInSnapshot",
            "baseName": "malwareDetectedInSnapshot",
            "type": "SecuritySnapshotNotificationArguments",
            "format": ""
        },
        {
            "name": "dataAnomalyDetectedInSnapshot",
            "baseName": "dataAnomalyDetectedInSnapshot",
            "type": "SecuritySnapshotNotificationArguments",
            "format": ""
        },
        {
            "name": "malwareRemediated",
            "baseName": "malwareRemediated",
            "type": "SecurityResourceNotificationArguments",
            "format": ""
        },
        {
            "name": "dataAnomalyRemediated",
            "baseName": "dataAnomalyRemediated",
            "type": "SecurityResourceNotificationArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NotificationArguments.attributeTypeMap;
    }
    constructor() {
    }
}
